import {
  ISourceEntityTypes,
  SourceEntityMigrationType,
  type ISourceEntity,
} from '@principle-theorem/practice-migrations/interfaces';
import { TypeGuard } from '@principle-theorem/shared';
import { flow, isBoolean, isNumber, isString } from 'lodash';
import { STAFFER_RESOURCE_TYPE } from '../../../destination/entities/staff';
import { BaseSourceEntity } from '../../../source/base-source-entity';
import { SourceEntity } from '../../../source/source-entity';
import { convertNullToUndefinedFn } from '../../../source/source-helpers';
import { STAFF_DESTINATION_ENTITY } from '../../destination/entities/staff';
import { cleanObjectStrings } from './lib/conversion-helpers';

export const STAFFER_SOURCE_ENTITY: ISourceEntity = SourceEntity.init({
  metadata: {
    label: 'Staffer List',
    description: '',
    idPrefix: STAFFER_RESOURCE_TYPE,
    migrationType: SourceEntityMigrationType.Automatic,
  },
});

export interface ID4WStaffer {
  id: number;
  surname: string;
  first_name: string;
  provider_no: string;
  practice_id: number;
  is_active?: boolean;
}

function isD4WStafferListItem(
  item: unknown,
  logError: boolean
): item is ID4WStaffer {
  return TypeGuard.interface<ID4WStaffer>(
    {
      id: isNumber,
      surname: isString,
      first_name: isString,
      provider_no: isString,
      practice_id: isNumber,
      is_active: TypeGuard.nilOr(isBoolean),
    },
    logError
  )(item);
}

const STAFFER_SOURCE_QUERY = `SELECT
  member_id AS id,
  firstname AS first_name,
  surname,
  provider_no_1_id AS provider_no,
  practice_id,
  convert_to_boolean(is_active) AS is_active
FROM staff
WHERE member_id != '-1' AND member_id IS NOT NULL
ORDER BY id
`;

export type D4WStaffer = ISourceEntityTypes<ID4WStaffer>;

export class StafferSourceEntity extends BaseSourceEntity<D4WStaffer> {
  sourceEntity = STAFFER_SOURCE_ENTITY;
  entityResourceType = STAFFER_RESOURCE_TYPE;
  sourceQuery = STAFFER_SOURCE_QUERY;
  migrationDestinations = [STAFF_DESTINATION_ENTITY.metadata.key];
  verifySourceFn = isD4WStafferListItem;

  override transformDataFn = flow([
    convertNullToUndefinedFn(),
    (rows: ID4WStaffer[]) => rows.map(cleanObjectStrings),
  ]);

  translate(_staffer: ID4WStaffer): object {
    return {};
  }

  getSourceRecordId(data: ID4WStaffer): number {
    return data.id;
  }

  getSourceLabel(data: ID4WStaffer): string {
    return `${data.first_name} ${data.surname}`;
  }
}
